export default __webpack_public_path__ + "ac4df5afd8cf2d384b9b54f90827a2cc.wav";